import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
import { AUFlagIcons, CloseDialogIcon, MapPinIcon } from "assets/styles/icons";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleUpdateAccount } from "../../introduction/YourDetails";
import { ProfileActions } from "state/profile/Action";
import {
  AppFormikSelect,
  AppFormikTextField,
  AppPrimaryButton,
  AppSecondaryButton,
} from "shared/components/AppComponents";
import { Formik } from "formik";
import {
  PropertyDetailsReviewSchema,
  RegisterSchema,
  YourBusinessReviewSchema,
  YourLoanReviewSchema,
} from "shared/helpers/Schema";
import { handleSaveLoan } from "../../introduction/YourLoan";
import { ExpandMore } from "@mui/icons-material";
import {
  BROKER_COMMISSION_RATE,
  ENTITY_TYPE,
  EXPECTED_TIME,
  LOAN_PURPOSE,
  LOANPAYBACK_OPTION,
  MORGAGE_OPTIONS,
  PROPERTY_TYPE,
  REPAYMENT_METHOD,
} from "shared/helpers/Constants";
import Utils from "shared/helpers/Utils";
import {
  handleCheckABN,
  handleSaveBusiness,
} from "../../introduction/YourBusiness";
import AccordionReviewComponents from "./AccordionReviewComponents";
import { handleSaveProperty } from "../../security/LiabilitiesLegalTies";
import Toast from "shared/helpers/Toast";
import DialogAddProperty from "../dialog/DialogAddProperty";
import DialogDeleteProperty from "../dialog/DialogDeleteProperty";
import DialogFirstMortgage from "../dialog/DialogFirstMortgage";
import { useNavigate } from "react-router-dom";
import { useProgress } from "context/ProgressProvider";
import dayjs from "dayjs";
import { DateCalendar } from "@mui/x-date-pickers";

let newProperty = {
  propertyType: "-",
  propertyAddress: "-",
  estimatedPropertyAmount: 0,
  isAnyExistingLoan: false,
  existingLoanSettlementOption: "",
  existingLoanAmount: null,
  isAnyCaveats: false,
};

export const handleNoOfPropertiesChange = (
  newCount,
  currentProfile,
  formValues,
) => {
  let resultProperties;
  const currentProperties = [...currentProfile.properties];
  const currentCount = currentProperties.length;

  if (newCount < currentCount) {
    const updatedProperties = currentProperties.slice(0, newCount);

    resultProperties = {
      ...formValues,
      noOfProperties: newCount,
      fullProperties: updatedProperties,
      selectedProperty:
        formValues.selectedProperty >= newCount
          ? 0
          : formValues.selectedProperty,
      ...(formValues.selectedProperty >= newCount &&
      updatedProperties.length > 0
        ? {
            propertyType: updatedProperties[0].propertyType,
            propertyAddress: updatedProperties[0].propertyAddress,
            estimatedPropertyAmount: Utils.formatCurrency(
              updatedProperties[0].estimatedPropertyAmount,
            ),
            isAnyExistingLoan: updatedProperties[0].isAnyExistingLoan,
            existingLoanSettlementOption:
              updatedProperties[0].existingLoanSettlementOption,
            existingLoanAmount: Utils.formatCurrency(
              updatedProperties[0].existingLoanAmount,
            ),
            isAnyCaveats: updatedProperties[0].isAnyCaveats,
          }
        : {}),
    };
  } else if (newCount > currentCount) {
    const propertiesToAdd = newCount - currentCount;
    const newProperties = Array(propertiesToAdd)
      .fill(null)
      .map(() => ({ ...newProperty }));
    const updatedProperties = [...currentProperties, ...newProperties];

    resultProperties = {
      ...formValues,
      noOfProperties: newCount,
      fullProperties: updatedProperties,
    };
  } else {
    resultProperties = {
      ...formValues,
      noOfProperties: newCount,
    };
  }

  return resultProperties;
};

const PropertyKeyEnum = {
  "property-1": "noOfProperties",
  "property-2": "propertyType",
  "property-3": "propertyAddress",
  "property-4": "estimatedPropertyAmount",
  "property-5": "isAnyExistingLoan",
  "property-6": "existingLoanSettlementOption",
  "property-7": "existingLoanAmount",
  "property-8": "isAnyCaveats",
};

const AccordionReviewDetails: React.FC = () => {
  const [expanded, setExpanded] = useState<string | false>("panel1");
  const [showDialog, setShowDialog] = useState<string>("");
  const [showRemoveCaveats, setShowRemoveCaveats] = useState(false);
  const [showDialogAddProperty, setShowDialogAddProperty] = useState(false);
  const [numberNewProperties, setNumberNewProperties] = useState(0);
  const [showDialogDelete, setShowDialogDelete] = useState(false);
  const [selectedIndexProperty, setSelectedIndexProperty] = useState(0);
  const [existingLoanStatus, setExistingLoanStatus] = useState("Native");
  const [properySecurityRequired, setProperySecurityRequired] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentProfile, isBroker } = useProgress();

  const handleCloseRemoveCaveats = () => {
    setShowRemoveCaveats(false);
  };

  const handleChange =
    (panel: string) => (event: React.MouseEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  const isMultiProperties = currentProfile.properties.length > 1 ? true : false;

  const LIST_PROPERTY = (selectedPropertyType: any) => {
    let formatedMenu = currentProfile.properties.map((property, index) => ({
      value: index,
      // label: `Property ${index + 1} - ${property[PropertyKeyEnum[showDialog]]}`,
      label: `Property ${index + 1}`,
    }));
    return formatedMenu;
  };

  const checkUpdateData = (data) => {
    if (data) {
      if (data.includes("details")) {
        return { title: "your details", name: "details" };
      }

      if (data.includes("loan")) {
        return { title: "your loan", name: "loan" };
      }

      if (data.includes("business")) {
        return { title: "your business", name: "business" };
      }

      if (data.includes("property")) {
        return { title: "property details", name: "property" };
      }
    }
  };

  const handleSuccessForm = (data) => {
    dispatch(ProfileActions.setSblProfile(data));
    setShowDialog("");
  };
  const handleSuccessMultiProperties = (data) => {
    dispatch(
      ProfileActions.setSblProfile({
        properties: data.fullProperties,
        noOfProperties: data.noOfProperties,
        //update single
        propertyType: data.fullProperties[0].propertyType,
        propertyAddress: data.fullProperties[0].propertyAddress,
        estimatedPropertyAmount: data.fullProperties[0].estimatedPropertyAmount,
        isAnyExistingLoan: data.fullProperties[0].isAnyExistingLoan,
        existingLoanSettlementOption:
          data.fullProperties[0].existingLoanSettlementOption,
        existingLoanAmount: data.fullProperties[0].existingLoanAmount,
        isAnyCaveats: data.fullProperties[0].isAnyCaveats,
      }),
    );
    setShowDialog("");
  };

  const handleSubmitForm = (data, formValues, formik, showDialog) => {
    const updateBusiness = (data) => {
      handleSaveBusiness(data, currentProfile.loadId, (response) => {
        if (response === "monthly-empty") {
          navigate("/sbl/intro-business/4");
          return;
        }
        if (response) {
          handleSuccessForm({
            abn: data.abn,
            registeredEntityName: data.registeredEntityName,
            entityAddress: data.entityAddress,
            entityType: data.entityType,
            legalEntityType: data.legalEntityType,
          });
        }
      });
    };

    if (data) {
      if (data.name === "details") {
        handleUpdateAccount(formValues, formik, (ev) => {
          handleSuccessForm(formValues);
        });
      }
      if (data.name === "loan") {
        let loanValues =
          formValues.expectedTime !== "I have a specific date"
            ? { ...formValues, expectedLoanDate: null }
            : formValues;
        handleSaveLoan(
          loanValues,
          currentProfile.loadId,
          () => {
            handleSuccessForm(formValues);
            handleSaveBusiness(currentProfile, currentProfile.loadId, () => {});
          },
          null,
          isBroker,
        );
      }
      if (data.name === "business") {
        let repaymentStatus =
          formValues.repaymentMethod === "Interest Capitalised" || false;
        let data = {
          abn: formValues.abn.toString(),
          entityType: formValues.entityType,
          legalEntityType: formValues.legalEntityType,
          isMonthlyRepayment: repaymentStatus ? false : true,
          // averageMonthlyTurnOver: repaymentStatus ? 0 : 1000,
          // totalBusinessAssets: repaymentStatus ? 0 : 1000,
          // totalBusinessLiabilities: repaymentStatus ? 0 : 1000,
          averageMonthlyTurnOver: repaymentStatus
            ? 0
            : parseFloat(
                String(formValues.averageMonthlyTurnOver).replace(/,/g, ""),
              ),
          totalBusinessAssets: repaymentStatus
            ? 0
            : parseFloat(
                String(formValues.totalBusinessAssets).replace(/,/g, ""),
              ),
          totalBusinessLiabilities: repaymentStatus
            ? 0
            : parseFloat(
                String(formValues.totalBusinessLiabilities).replace(/,/g, ""),
              ),
          isReviewConfirmed: true,
          isABNVerified: true,
          registeredEntityName: formValues.registeredEntityName,
          entityAddress: formValues.entityAddress,
          repaymentMethod: currentProfile.repaymentMethod,
        };
        if (showDialog === "business-3") {
          handleCheckABN(formValues, (ev) => {
            if (ev) {
              updateBusiness({
                ...data,
                registeredEntityName: ev.registeredEntityName,
                entityAddress: `${ev.postcode} ${ev.state}`,
              });
            }
            formik.setSubmitting(false);
          });
          return;
        }
        updateBusiness(data);
      }
      if (data.name === "property") {
        if (showDialog === "property-1") {
          if (formValues.noOfProperties < 1) {
            Toast.showErrorMessage(
              "Unable to update. Add at least 1 property to continue",
            );
            formik.setSubmitting(false);
            return;
          }
          if (formValues.noOfProperties > currentProfile.noOfProperties) {
            setShowDialog("");
            setExistingLoanStatus("Add");
            setShowDialogAddProperty(true);
            setNumberNewProperties(formValues.noOfProperties);
            return;
          }

          setShowDialogDelete(formValues);
          formik.setSubmitting(false);
          return;
        }
        if (showDialog === "property-5") {
        }
        if (showDialog === "property-8") {
          if (formValues.isAnyCaveats) {
            setShowRemoveCaveats(true);
            formik.setSubmitting(false);
            return;
          }
        }
        if (isMultiProperties) {
          handleSaveProperty(
            true,
            {
              isPropertyOwned: true,
              noOfProperties: formValues.noOfProperties,
              properties: formValues.fullProperties.map(
                ({ isAllDataFilled, _id, ...rest }) => rest,
              ),
            },
            currentProfile.loadId,
            (res) => {
              if (res) {
                handleSuccessMultiProperties(formValues);
              } else {
                formik.setSubmitting(false);
              }
            },
          );
        } else {
          handleSaveProperty(
            false,
            {
              isPropertyOwned: true,
              noOfProperties: formValues.noOfProperties,
              propertyType: formValues.propertyType,
              propertyAddress: formValues.propertyAddress,
              estimatedPropertyAmount: formValues.estimatedPropertyAmount
                ? parseFloat(
                    String(formValues.estimatedPropertyAmount).replace(
                      /,/g,
                      "",
                    ),
                  )
                : null,
              isAnyExistingLoan: formValues.isAnyExistingLoan,
              existingLoanSettlementOption:
                formValues.existingLoanSettlementOption,
              existingLoanAmount:
                parseFloat(
                  String(formValues.existingLoanAmount).replace(/,/g, ""),
                ) || 0,
              isAnyCaveats: formValues.isAnyCaveats || false,
            },
            currentProfile.loadId,
            (res) => {
              if (res) {
                handleSuccessForm(formValues);
              } else {
                formik.setSubmitting(false);
              }
            },
          );
        }
      }
    }
  };

  const handleShowDialogAddProperty = (e) => {
    setExistingLoanStatus("Native");
    setShowDialogAddProperty(e);
  };

  const handleOpenMortgage = () => {
    setProperySecurityRequired("mortgage");
  };

  return (
    <React.Fragment>
      {/* Your details */}
      <Dialog
        open={showDialog !== ""}
        fullWidth
        maxWidth="sm"
        onClose={() => {
          setShowDialog("");
          setExistingLoanStatus("Native");
          setSelectedIndexProperty(0);
        }}
      >
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h2">
              Update {checkUpdateData(showDialog)?.title}
            </Typography>
          </Box>
        </DialogTitle>

        <Formik
          enableReinitialize
          validationSchema={
            checkUpdateData(showDialog)?.name === "details"
              ? RegisterSchema
              : checkUpdateData(showDialog)?.name === "loan"
                ? YourLoanReviewSchema
                : checkUpdateData(showDialog)?.name === "business"
                  ? YourBusinessReviewSchema
                  : checkUpdateData(showDialog)?.name === "property"
                    ? isMultiProperties
                      ? PropertyDetailsReviewSchema(
                          currentProfile.properties[selectedIndexProperty],
                          existingLoanStatus,
                        )
                      : PropertyDetailsReviewSchema(
                          currentProfile,
                          existingLoanStatus,
                        )
                    : ""
          }
          validateOnMount
          onSubmit={(formValues, formik) => {
            formik.setSubmitting(true);
            handleSubmitForm(
              checkUpdateData(showDialog),
              formValues,
              formik,
              showDialog,
            );
          }}
          initialValues={
            checkUpdateData(showDialog)?.name === "details"
              ? {
                  firstName: currentProfile.firstName,
                  lastName: currentProfile.lastName,
                  email: currentProfile.email,
                  phoneNumber: currentProfile.phoneNumber || "+61 ",
                }
              : checkUpdateData(showDialog)?.name === "loan"
                ? {
                    loanAmount: Utils.formatCurrency(currentProfile.loanAmount),
                    loanTerm: currentProfile.loanTerm,
                    expectedTime: currentProfile.expectedTime,
                    repaymentMethod: currentProfile.repaymentMethod,
                    loanPurpose: currentProfile.loanPurpose,
                    loanPayBackOption: currentProfile.loanPayBackOption,
                    expectedLoanDate: currentProfile.expectedLoanDate,
                    brokerCommissionRate: currentProfile.brokerCommissionRate,
                  }
                : checkUpdateData(showDialog)?.name === "business"
                  ? {
                      entityType: currentProfile.entityType,
                      legalEntityType: currentProfile.legalEntityType,
                      registeredEntityName: currentProfile.registeredEntityName,
                      abn: currentProfile.abn,
                      entityAddress: currentProfile.entityAddress,
                      averageMonthlyTurnOver:
                        currentProfile.averageMonthlyTurnOver,
                      totalBusinessAssets: currentProfile.totalBusinessAssets,
                      totalBusinessLiabilities:
                        currentProfile.totalBusinessLiabilities,
                    }
                  : checkUpdateData(showDialog)?.name === "property"
                    ? isMultiProperties
                      ? {
                          selectedProperty: 0,
                          fullProperties: currentProfile.properties,
                          noOfProperties: currentProfile.noOfProperties,
                          propertyType:
                            currentProfile.properties[0].propertyType,
                          propertyAddress:
                            currentProfile.properties[0].propertyAddress,
                          estimatedPropertyAmount: Utils.formatCurrency(
                            currentProfile.properties[0]
                              .estimatedPropertyAmount,
                          ),
                          isAnyExistingLoan:
                            currentProfile.properties[0].isAnyExistingLoan,
                          existingLoanSettlementOption:
                            currentProfile.properties[0]
                              .existingLoanSettlementOption,
                          existingLoanAmount: Utils.formatCurrency(
                            currentProfile.properties[0].existingLoanAmount,
                          ),
                          isAnyCaveats:
                            currentProfile.properties[0].isAnyCaveats,
                        }
                      : {
                          noOfProperties: currentProfile.noOfProperties,
                          propertyType: currentProfile.propertyType,
                          propertyAddress: currentProfile.propertyAddress,
                          estimatedPropertyAmount: Utils.formatCurrency(
                            currentProfile.estimatedPropertyAmount,
                          ),
                          isAnyExistingLoan: currentProfile.isAnyExistingLoan,
                          existingLoanSettlementOption:
                            currentProfile.existingLoanSettlementOption,
                          existingLoanAmount: Utils.formatCurrency(
                            currentProfile.existingLoanAmount,
                          ),
                          isAnyCaveats: currentProfile.isAnyCaveats,
                        }
                    : {}
          }
        >
          {({
            handleSubmit,
            errors,
            isSubmitting,
            values,
            setValues,
            dirty,
          }: any) => {
            const handlePropertyChange = (selectedIndex) => {
              const selectedProp = values.fullProperties[selectedIndex];
              console.log(values);

              if (selectedProp) {
                setValues({
                  ...values,
                  selectedProperty: selectedIndex,
                  propertyType: selectedProp.propertyType,
                  propertyAddress: selectedProp.propertyAddress,
                  estimatedPropertyAmount: Utils.formatCurrency(
                    selectedProp.estimatedPropertyAmount,
                  ),
                  isAnyExistingLoan: selectedProp.isAnyExistingLoan,
                  existingLoanSettlementOption:
                    selectedProp.existingLoanSettlementOption,
                  existingLoanAmount: Utils.formatCurrency(
                    selectedProp.existingLoanAmount,
                  ),
                  isAnyCaveats: selectedProp.isAnyCaveats,
                });
              }

              setSelectedIndexProperty(selectedIndex);
            };

            const updatePropertyData = (fieldName, value) => {
              const selectedIndex = values.selectedProperty;
              const updatedProperties = [...values.fullProperties];

              let processedValue = value;

              if (fieldName === "existingLoanSettlementOption") {
                if (value === "I’ll decide later") {
                  setShowDialog("");
                  handleOpenMortgage();
                }
              }
              if (
                fieldName === "estimatedPropertyAmount" ||
                fieldName === "existingLoanAmount"
              ) {
                processedValue = parseFloat(String(value).replace(/,/g, ""));
              }

              console.log(fieldName);
              if (fieldName === "isAnyExistingLoan") {
                if (value === false) {
                  updatedProperties[selectedIndex][
                    "existingLoanSettlementOption"
                  ] = "";
                  updatedProperties[selectedIndex]["existingLoanAmount"] = "";
                }
              }

              // updatedProperties[selectedIndex] = {
              //   ...updatedProperties[selectedIndex],
              //   [fieldName]: processedValue,
              // };

              updatedProperties[selectedIndex][fieldName] = processedValue;

              setValues({
                ...values,
                [fieldName]: value,
                fullProperties: updatedProperties,
              });
            };

            return (
              <>
                <DialogContent>
                  <form
                    autoComplete="off"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                      }
                    }}
                  >
                    <>
                      {showDialog === "details-1" && (
                        <>
                          <Box mt={3}>
                            <AppFormikTextField
                              placeholder="First name"
                              label="First name"
                              name="firstName"
                              outerLabel
                              className="ezifin-default-field"
                            />
                          </Box>

                          <Box mt={3}>
                            <AppFormikTextField
                              placeholder="Last name"
                              label="Last name"
                              name="lastName"
                              outerLabel
                              className="ezifin-default-field"
                            />
                          </Box>
                        </>
                      )}
                      {showDialog === "details-2" && (
                        <Box mt={3}>
                          <AppFormikTextField
                            placeholder="Email address"
                            label="Email address"
                            name="email"
                            outerLabel
                            className="ezifin-default-field cursor-not-allowed"
                            inputProps={{ readOnly: true }}
                            blockedAndReadOnly={true}
                          />
                        </Box>
                      )}
                      {showDialog === "details-3" && (
                        <Box mt={3}>
                          <AppFormikTextField
                            placeholder="Phone number"
                            label="Phone number"
                            name="phoneNumber"
                            outerLabel
                            className="ezifin-default-field"
                            slotProps={{
                              input: {
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <AUFlagIcons />
                                  </InputAdornment>
                                ),
                              },
                            }}
                            type="customAUPhone"
                          />
                        </Box>
                      )}
                    </>

                    <>
                      {showDialog === "loan-1" && (
                        <AppFormikTextField
                          placeholder="Enter amount"
                          label="Loan Amount"
                          name="loanAmount"
                          outerLabel
                          className="ezifin-default-field"
                          slotProps={{
                            input: {
                              startAdornment: (
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              ),
                            },
                          }}
                          customIsoDollar
                        />
                      )}

                      {showDialog === "loan-2" && (
                        <AppFormikTextField
                          placeholder="Enter duration (Months)"
                          label="Loan term"
                          name="loanTerm"
                          outerLabel
                          className="ezifin-default-field"
                          type="number"
                        />
                      )}

                      {showDialog === "loan-3" && (
                        <AppFormikSelect
                          placeholder="Select"
                          label="Funding time"
                          name="expectedTime"
                          items={EXPECTED_TIME}
                          valueKey="value"
                          titleKey="label"
                          outerLabel
                          iconComponent={ExpandMore}
                          className="ezifin-default-field"
                          labelSize={16}
                          onChange={(e) => {
                            if (values.expectedTime === e.target.value) {
                              return;
                            }
                            if (e.target.value === "I have a specific date") {
                              navigate("/sbl/intro-loan/3");
                            }
                          }}
                        />
                      )}
                      {showDialog === "loan-4" && (
                        <DateCalendar
                          disabled={
                            currentProfile.isAllowedToEdit?.reviewDetails ===
                            null
                              ? false
                              : currentProfile.isAllowedToEdit
                                    ?.reviewDetails === undefined
                                ? false
                                : !currentProfile.isAllowedToEdit?.reviewDetails
                          }
                          minDate={dayjs()}
                          onChange={(date) => {
                            const formattedDate =
                              dayjs(date).format("YYYY-MM-DD");
                            setValues({
                              ...values,
                              expectedLoanDate: formattedDate,
                            });
                          }}
                          slotProps={{
                            day: {
                              sx: {
                                "&.MuiPickersDay-root.Mui-selected": {
                                  backgroundColor: "#2d68f7",
                                  color: "white",
                                },
                              },
                            },
                          }}
                          sx={{
                            "&.MuiDateCalendar-root": {
                              maxWidth: "100%",
                            },
                          }}
                          {...(currentProfile.expectedLoanDate
                            ? { value: dayjs(values.expectedLoanDate) }
                            : {})}
                        />
                      )}
                      {showDialog === "loan-5" && (
                        <AppFormikSelect
                          placeholder="Select"
                          label="Preferred repayment"
                          name="repaymentMethod"
                          items={REPAYMENT_METHOD}
                          valueKey="value"
                          titleKey="label"
                          outerLabel
                          iconComponent={ExpandMore}
                          className="ezifin-default-field"
                          labelSize={16}
                          onChange={(e) => {
                            if (values.repaymentMethod === e.target.value) {
                              return;
                            }
                            if (
                              e.target.value ===
                              "Interest only (monthly in advance)"
                            ) {
                              navigate("/sbl/intro-loan/5");
                            }
                          }}
                        />
                      )}
                      {(showDialog === "loan-5" &&
                        values.repaymentMethod ===
                          "Interest only (monthly in advance)") ||
                        (showDialog === "loan-6" && (
                          <AppFormikSelect
                            placeholder="Select"
                            label="Loan purpose"
                            name="loanPurpose"
                            items={LOAN_PURPOSE}
                            valueKey="value"
                            titleKey="label"
                            outerLabel
                            iconComponent={ExpandMore}
                            className="ezifin-default-field"
                            labelSize={16}
                          />
                        ))}
                      {showDialog === "loan-7" && (
                        <AppFormikSelect
                          placeholder="Select"
                          label="Loan Payback"
                          name="loanPayBackOption"
                          items={LOANPAYBACK_OPTION}
                          valueKey="value"
                          titleKey="label"
                          outerLabel
                          iconComponent={ExpandMore}
                          className="ezifin-default-field"
                          labelSize={16}
                        />
                      )}
                      {isBroker && showDialog === "loan-8" && (
                        <AppFormikSelect
                          placeholder="Select"
                          label="Broker Commission Rate"
                          name="brokerCommissionRate"
                          items={BROKER_COMMISSION_RATE}
                          valueKey="value"
                          titleKey="label"
                          outerLabel
                          iconComponent={ExpandMore}
                          className="ezifin-default-field"
                          labelSize={16}
                        />
                      )}
                    </>

                    <>
                      {showDialog === "business-1" && (
                        <AppFormikSelect
                          placeholder="Select"
                          name="entityType"
                          label="Entity type"
                          items={ENTITY_TYPE}
                          valueKey="value"
                          titleKey="label"
                          outerLabel
                          iconComponent={ExpandMore}
                          className="ezifin-default-field"
                          labelSize={16}
                        />
                      )}
                      {showDialog === "business-2" && (
                        <AppFormikTextField
                          placeholder="Legal entity name"
                          label="Entity name"
                          name="legalEntityType"
                          outerLabel
                          className="ezifin-default-field"
                          allowComma
                        />
                      )}
                      {showDialog === "business-3" && (
                        <AppFormikTextField
                          placeholder="Enter ABN number"
                          label="ABN"
                          name="abn"
                          outerLabel
                          className="ezifin-default-field"
                          removeSpacing
                          returnAsString
                        />
                      )}
                      {showDialog === "business-4" && (
                        <AppFormikTextField
                          placeholder="Registered entity name"
                          label="Registered entity name"
                          name="registeredEntityName"
                          outerLabel
                          className="ezifin-default-field"
                        />
                      )}
                      {showDialog === "business-5" && (
                        <AppFormikTextField
                          placeholder="Registered entity address"
                          label="Entity address"
                          name="entityAddress"
                          outerLabel
                          className="ezifin-default-field"
                          allowComma
                        />
                      )}
                    </>

                    <>
                      {showDialog.includes("property") &&
                        showDialog !== "property-1" &&
                        isMultiProperties && (
                          <Box mb={3}>
                            <AppFormikSelect
                              placeholder="Select"
                              label="Select property"
                              name="selectedProperty"
                              items={LIST_PROPERTY(showDialog)}
                              valueKey="value"
                              titleKey="label"
                              outerLabel
                              iconComponent={ExpandMore}
                              className="ezifin-default-field"
                              onChange={(e) =>
                                handlePropertyChange(e.target.value)
                              }
                              labelSize={16}
                            />
                          </Box>
                        )}
                      {showDialog === "property-1" && (
                        <AppFormikTextField
                          label="Number of properties"
                          name="noOfProperties"
                          outerLabel
                          className="ezifin-default-field"
                          type="number"
                        />
                      )}
                      {showDialog === "property-2" && (
                        <AppFormikSelect
                          placeholder="Select"
                          label="Property type"
                          name="propertyType"
                          items={PROPERTY_TYPE}
                          valueKey="value"
                          titleKey="label"
                          outerLabel
                          iconComponent={ExpandMore}
                          className="ezifin-default-field"
                          onChange={(e) => {
                            if (isMultiProperties)
                              updatePropertyData(
                                "propertyType",
                                e.target.value,
                              );
                          }}
                          labelSize={16}
                        />
                      )}
                      {showDialog === "property-3" && (
                        <AppFormikTextField
                          placeholder="Address"
                          label="Property address"
                          name="propertyAddress"
                          outerLabel
                          className="ezifin-default-field"
                          slotProps={{
                            input: {
                              endAdornment: (
                                <InputAdornment position="end">
                                  <MapPinIcon />
                                </InputAdornment>
                              ),
                            },
                          }}
                          allowComma={true}
                          onChange={(e) => {
                            if (isMultiProperties)
                              updatePropertyData(
                                "propertyAddress",
                                e.target.value,
                              );
                          }}
                        />
                      )}
                      {showDialog === "property-4" && (
                        <AppFormikTextField
                          placeholder="Value"
                          label="Estimated property amount"
                          name="estimatedPropertyAmount"
                          outerLabel
                          className="ezifin-default-field"
                          slotProps={{
                            input: {
                              startAdornment: (
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              ),
                            },
                          }}
                          allowComma={true}
                          customIsoDollarDecimal
                          onChange={(e) => {
                            if (isMultiProperties)
                              updatePropertyData(
                                "estimatedPropertyAmount",
                                e.target.value,
                              );
                          }}
                        />
                      )}
                      {showDialog === "property-5" && (
                        <AppFormikSelect
                          placeholder="Select"
                          label="Any existing loan"
                          name="isAnyExistingLoan"
                          items={[
                            {
                              value: true,
                              label: "Yes",
                            },
                            {
                              value: false,
                              label: "No",
                            },
                          ]}
                          valueKey="value"
                          titleKey="label"
                          outerLabel
                          iconComponent={ExpandMore}
                          className="ezifin-default-field"
                          onChange={(e) => {
                            if (isMultiProperties)
                              updatePropertyData(
                                "isAnyExistingLoan",
                                e.target.value,
                              );
                          }}
                          labelSize={16}
                        />
                      )}
                      {((values.isAnyExistingLoan &&
                        showDialog === "property-5") ||
                        showDialog === "property-6") && (
                        <Box
                          sx={{
                            marginTop: values.isAnyExistingLoan ? "8px" : "",
                          }}
                        >
                          {" "}
                          {values.isAnyExistingLoan ? (
                            <AppFormikSelect
                              placeholder="Select"
                              label="Existing loan settlement"
                              name="existingLoanSettlementOption"
                              items={MORGAGE_OPTIONS}
                              valueKey="value"
                              titleKey="label"
                              outerLabel
                              iconComponent={ExpandMore}
                              className="ezifin-default-field"
                              onChange={(e) => {
                                if (isMultiProperties) {
                                  updatePropertyData(
                                    "existingLoanSettlementOption",
                                    e.target.value,
                                  );
                                } else {
                                  if (e.target.value === "I’ll decide later") {
                                    setShowDialog("");
                                    handleOpenMortgage();
                                  }
                                }
                              }}
                              labelSize={16}
                            />
                          ) : (
                            <Typography variant="body1" className="p-1">
                              <i style={{ color: "gray" }}>
                                There's no existing loan
                              </i>
                            </Typography>
                          )}
                        </Box>
                      )}
                      {((values.isAnyExistingLoan &&
                        showDialog === "property-5") ||
                        showDialog === "property-7") && (
                        <Box
                          sx={{
                            marginTop: values.isAnyExistingLoan ? "8px" : "",
                          }}
                        >
                          {values.isAnyExistingLoan ? (
                            <AppFormikTextField
                              placeholder="Enter amount"
                              label="Existing loan amount"
                              name="existingLoanAmount"
                              outerLabel
                              className="ezifin-default-field"
                              slotProps={{
                                input: {
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      $
                                    </InputAdornment>
                                  ),
                                },
                              }}
                              customIsoDollar
                              onChange={(e) => {
                                if (isMultiProperties)
                                  updatePropertyData(
                                    "existingLoanAmount",
                                    e.target.value,
                                  );
                              }}
                            />
                          ) : (
                            <Typography variant="body1" className="p-1">
                              <i style={{ color: "gray" }}>
                                There's no existing loan
                              </i>
                            </Typography>
                          )}
                        </Box>
                      )}
                      {showDialog === "property-8" && (
                        <AppFormikSelect
                          placeholder="Select"
                          label="Any caveats"
                          name="isAnyCaveats"
                          items={[
                            {
                              value: true,
                              label: "Yes",
                            },
                            {
                              value: false,
                              label: "No",
                            },
                          ]}
                          valueKey="value"
                          titleKey="label"
                          outerLabel
                          iconComponent={ExpandMore}
                          className="ezifin-default-field"
                          onChange={(e) => {
                            if (isMultiProperties)
                              updatePropertyData(
                                "isAnyCaveats",
                                e.target.value,
                              );
                          }}
                          labelSize={16}
                        />
                      )}
                    </>
                  </form>
                </DialogContent>
                <DialogActions>
                  <Box
                    sx={{
                      display: "flex",
                      gap: "12px",
                      width: "100%",
                      paddingTop: "12px",
                    }}
                  >
                    <AppSecondaryButton
                      title="Cancel"
                      className="btn-small"
                      onClick={() => {
                        setExistingLoanStatus("Native");
                        setShowDialog("");
                        setSelectedIndexProperty(0);
                      }}
                      fullWidth
                    />
                    <AppPrimaryButton
                      title="Update"
                      isLoading={isSubmitting}
                      loadingText="Please wait.."
                      onClick={handleSubmit}
                      disabled={
                        !dirty ||
                        (showDialog === "loan-6" &&
                          values.loanPurpose === "") ||
                        (showDialog === "loan-7" &&
                          values.loanPayBackOption === "") ||
                        (showDialog === "property-6" &&
                          values.existingLoanSettlementOption === "") ||
                        (showDialog === "property-7" &&
                          values.existingLoanAmount === "") ||
                        isSubmitting ||
                        Object.keys(errors).length > 0
                      }
                      fullWidth
                    />
                  </Box>
                </DialogActions>
              </>
            );
          }}
        </Formik>
      </Dialog>

      <DialogFirstMortgage
        properySecurityRequired={properySecurityRequired}
        setProperySecurityRequired={setProperySecurityRequired}
      />

      <DialogAddProperty
        showDialogAddProperty={showDialogAddProperty}
        setShowDialogAddProperty={(e) => handleShowDialogAddProperty(e)}
        numberNewProperties={numberNewProperties}
        setShowRemoveCaveats={setShowRemoveCaveats}
        handleOpenMortgage={handleOpenMortgage}
      />

      <DialogDeleteProperty
        showDialogDelete={showDialogDelete}
        setShowDialogDelete={setShowDialogDelete}
        callback={(e, resultProperties) => {
          if (e) {
            handleSuccessMultiProperties(resultProperties);
            setShowDialogDelete(false);
          }
        }}
      />

      <Dialog open={showRemoveCaveats} fullWidth maxWidth="sm">
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h2">Remove caveats</Typography>
            <IconButton onClick={() => handleCloseRemoveCaveats()}>
              <CloseDialogIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Typography variant="h3" fontWeight={400} mb={2}>
            For you to proceed with the application, you’ll need to remove the
            caveat/caveats from the property.
          </Typography>
        </DialogContent>

        <DialogActions sx={{ gap: "12px" }}>
          <AppSecondaryButton
            title="Cancel"
            className="btn-small ezifin-default-outlined-button"
            onClick={() => setShowRemoveCaveats(false)}
            fullWidth
          />
          <AppPrimaryButton
            title="Okay, I understand"
            className="btn-small"
            onClick={() => {
              handleCloseRemoveCaveats();
            }}
            fullWidth
          />
        </DialogActions>
      </Dialog>

      <AccordionReviewComponents
        expanded={expanded}
        handleChange={handleChange}
        setShowDialog={setShowDialog}
        setExistingLoanStatus={setExistingLoanStatus}
      />
    </React.Fragment>
  );
};

export default AccordionReviewDetails;
